<app-header-content-help-text [Heading]="'Locations page'" [helpText]="'A Complete Supply Chain Network Design'"></app-header-content-help-text>
<app-locations-organism></app-locations-organism>

